export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_MY_DATA = 'SET_MY_DATA';
export const SET_ME_RADIOLOGIST = 'SET_ME_RADIOLOGIST';
export const SET_ME_HOSPITAL = 'SET_ME_HOSPITAL';
export const SET_REGULARS = 'SET_REGULARS';
